import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import CloneableInputGroup from 'library/components/cloneable-input-group';
import { InputEvent as SyntheticEvent } from 'library/helpers/synthetic-events';
import Toggle from 'library/components/form-elements/toggle';
import Tag from 'library/components/tag';

const SocialMediaPlaceholder = (type) => {
    switch (type) {
        case 'twitter':
            return 'https://twitter.com/myaccount';
        case 'facebook':
            return 'https://facebook.com/myaccount';
        case 'gplus':
            return 'https://plus.google.com/+myaccount';
        case 'linkedin':
            return 'https://www.linkedin.com/in/myaccount/';
        case 'instagram':
            return 'https://www.instagram.com/myaccount/';
        default:
            return 'Social Media URL';
    }
}

const SocialFields = ({ className='', data, onChange, baseKey = '', index, active=false }) => {
    const remove = () => {
        onChange(new SyntheticEvent({
            name: baseKey,
            value: undefined,
            type: 'object'
        }));
    }

    const type = resolve(data, 'social_type', '');

    return (
        <div className={className}>
            <label>
                Social Type
                <select onChange={onChange} name={`${baseKey}.social_type`} value={type} disabled={!active} required={active}>
                    <option value="">--Select One--</option>
                    <option value="twitter">Twitter</option>
                    <option value="facebook">Facebook</option>
                    <option value="gplus">Google+</option>
                    <option value="linkedin">Linkedin</option>
                    <option value="instagram">Instagram</option>
                    <option value="other">Other</option>
                </select>
            </label>
            <label>
                Social Media URL
                <input placeholder={SocialMediaPlaceholder(type)} type="url" onChange={onChange} value={resolve(data, 'social_url', '')} name={`${baseKey}.social_url`} disabled={!!!type || !active} required={active} />
            </label>
            <div className="resume-builder-fields-controls">
                <span className="a" onClick={() => remove()}>remove</span>
            </div>
        </div>
    )
}

const Social = ({ data, handleChange }) => {
    const hasSocial = resolve(data, 'has_social', false, '.');

    const onChange = () => {
        handleChange(new SyntheticEvent({
            name: 'has_social',
            value: !hasSocial
        }));
    }

    const fieldsClass = [
        "resume-builder-fields",
        !hasSocial ? 'resume-builder-fields-disabled' : null
    ].filter(c=>c).join(' ')

    return (
        <section className={!hasSocial ? 'resume-builder-multi-disabled' : ''}>
            <h1><Toggle name="has_social" checked={hasSocial} onChange={onChange} /> Social <Tag className="tag-auxilary-3">Optional for Resume Creation</Tag></h1>
            <p>Tell us about the social media accounts you’d like to share with potential employers.  </p>
            <CloneableInputGroup disabled={!hasSocial} onChange={handleChange} values={data} dataKey="social" className="resume-builder-multi">
                <SocialFields className={fieldsClass} active={hasSocial} onChange={handleChange} />
            </CloneableInputGroup>
        </section>
    )
}


export default Social;
